import type { BrowserOptions } from '@sentry/browser';

export enum Severity {
    Fatal = 'fatal',
    Error = 'error',
    Warning = 'warning',
    Log = 'log',
    Info = 'info',
    Debug = 'debug',
}

export type BeforeSendType = BrowserOptions['beforeSend'];

export type ErrorLoggingConfiguration = {
    dataSourceName?: string;
    environment?: string;
    release?: string;
    beforeSend?: BeforeSendType;
};
